// Copyright 2018 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { Repository } from "repositories/Repository";

@autoinject
export class StorageRepository extends Repository {
    private authentication: IAuthentication;
    private webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler, authentication: IAuthentication) {
        super();

        this.authentication = authentication;
        this.webRequestHandler = webRequestHandler;
    }

    public getStorageSize(buId: string = null, queryString = ""): Promise<number> {
        const id = buId ? buId : this.authentication.businessUnitId;

        if (!id) return Promise.reject<number>("Not Authenticated");

        return this.webRequestHandler
            .createGetRequest<number>(Api.storage + "/" + id + "/Size") //?queryString=" + queryString
            .send()
            .then((x) => x.content);
    }

    public getProjectStorageSize(projectId: string): Promise<number> {
        return this.webRequestHandler
            .createGetRequest<number>(Api.storage + "/" + projectId + "/CloudSize")
            .send()
            .then((x) => x.content);
    }
}
